export const PLANK_TYPES = ["16-k", "20-k", "21-k"];

// Badge status lifecycle while an order is in the tork.
export const BADGE_STATUSES = ["ongoing", "open", "sample", "ready", "picking", "picked", "closed"];

// Statuses an order can have before it is started in the tork. These are the
// options offered by the status picker on the orders table.
export const PRE_TORK_STATUSES = ["planned", "unplanned", "closednotstarted"];

export const STATUS_LABELS = {
    planned: "Sågas nu",
    unplanned: "Oplanerad",
    closednotstarted: "Stängd ej startad",
    ongoing: "Pågående",
    open: "Öppen",
    sample: "Prov",
    ready: "Klar",
    picking: "Plockas",
    picked: "Tömd",
    closed: "Stängd"
};

export const STATUS_COLORS = {
    planned: "bg-gray-200 text-gray-800",
    unplanned: "bg-purple-200 text-purple-800",
    closednotstarted: "bg-amber-200 text-amber-800",
    ongoing: "bg-blue-200 text-blue-800",
    open: "bg-indigo-200 text-indigo-800",
    sample: "bg-yellow-200 text-yellow-800",
    ready: "bg-green-200 text-green-800",
    picking: "bg-orange-200 text-orange-800",
    picked: "bg-teal-200 text-teal-800",
    closed: "bg-gray-300 text-gray-600"
};

export const statusLabel = (status) => STATUS_LABELS[status] || status;
export const statusColor = (status) => STATUS_COLORS[status] || "bg-gray-200 text-gray-800";

// Tork note statuses (notes embedded on torks, see TorksManager/TorkNotesList).
export const NOTE_STATUSES = ["planned", "ongoing", "done"];

export const NOTE_STATUS_LABELS = {
    planned: "Planerad",
    ongoing: "Pågående",
    done: "Klar",
};

export const NOTE_STATUS_STYLES = {
    planned: "bg-blue-100 text-blue-700",
    ongoing: "bg-amber-100 text-amber-700",
    done: "bg-green-100 text-green-700",
};

export const noteStatusLabel = (status) => NOTE_STATUS_LABELS[status] || status;
export const noteStatusStyle = (status) => NOTE_STATUS_STYLES[status] || "bg-gray-100 text-gray-700";
